export const transformFormFieldValueMap = (formFieldValueMap) => {
  return {
    id: formFieldValueMap?.id,
    username: formFieldValueMap?.username || "",
    password: "",
    roleId: formFieldValueMap?.role?.id || null,
    status: formFieldValueMap?.status === "1" ? 1 : 0,
    alias: formFieldValueMap?.alias || "",
    companyName: formFieldValueMap?.companyName || "",
    editTime: formFieldValueMap?.modificationTimestamp
      ? new Date(
          formFieldValueMap?.modificationTimestamp * 1000
        ).toLocaleString()
      : "",
    modifiedBy: formFieldValueMap?.modifiedBy || "",
    location: formFieldValueMap?.locations?.map((loc) => loc.id) || [],
    menuAccessDTOS: formFieldValueMap?.menuAccessDTOS || [],
  };
};

export const Status = [
  { id: 0, name: "INACTIVE" },
  { id: 1, name: "ACTIVE" },
];

export const basicDetail = [
  {
    name: "username",
    rule: {
      required: false,
    },
    label: "Username",
    type: "text",
  },
  {
    name: "password",
    rule: {
      required: false,
    },
    label: "Password",
    type: "password",
  },
  {
    name: "roleId",
    rule: {
      required: true,
    },
    label: "Role",
    type: "dropdown",
  },
  {
    name: "status",
    rule: {
      required: true,
    },
    label: "Status",
    type: "dropdown",
  },
  {
    name: "location",
    rule: {
      required: true,
    },
    label: "Location",
    type: "dropdown",
  },
  {
    name: "alias",
    rule: {
      required: false,
    },
    label: "Alias",
    type: "text",
  },
];

export const editMode = [
  {
    name: "editTime",
    disabled: true,
    rule: {
      required: false,
    },
    label: "Edit Time",
    type: "text",
  },
  {
    name: "modifiedBy",
    disabled: true,
    rule: {
      required: false,
    },
    label: "Edit By",
    type: "text",
  },
];

export const UserBreadcrumb = [
  { label: "Dashboard", path: "/dashboard" },
  { label: "User", path: "/users" },
];
